import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 21H1.5v-3c0-2.481 2.019-4.5 4.5-4.5h6c2.481 0 4.5 2.019 4.5 4.5v3H15",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 19.5V12h3c2.481 0 4.5 2.019 4.5 4.5v3H21M9 12a4.505 4.505 0 01-4.5-4.5C4.5 5.019 6.519 3 9 3s4.5 2.019 4.5 4.5S11.481 12 9 12zm9-1.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 21H1.5v-3c0-2.481 2.019-4.5 4.5-4.5h6c2.481 0 4.5 2.019 4.5 4.5v3H15",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 19.5V12h3c2.481 0 4.5 2.019 4.5 4.5v3H21M9 12a4.505 4.505 0 01-4.5-4.5C4.5 5.019 6.519 3 9 3s4.5 2.019 4.5 4.5S11.481 12 9 12zm9-1.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 42H3v-6c0-4.962 4.038-9 9-9h12c4.962 0 9 4.038 9 9v6h-3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30 39V24h6c4.962 0 9 4.038 9 9v6h-3M18 24c-4.962 0-9-4.038-9-9s4.038-9 9-9 9 4.038 9 9-4.038 9-9 9zm18-3c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z",
    clipRule: "evenodd"
  }))
};
export var ClubFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});